// import { create } from 'zustand'

// const CategoryStore = create((set) => ({
//   category: '',
//   setCategory: (selectedCategory) => {
//     set({ category: selectedCategory }),
//     console.log('Category changed:', selectedCategory);
//   },
//   removeCategory: () => set({ category: '' }),
// }))

// export default CategoryStore;

import { create } from "zustand";
import { persist } from "zustand/middleware";

const CategoryStore = create(
  persist(
    (set) => ({
      category: "",
      setCategory: (selectedCategory) => {
        set({ category: selectedCategory });
        console.log("Category changed:", selectedCategory);
      },
      removeCategory: () => set({ category: "" }),
    }),
    {
      name: "category-storage",
      getStorage: () => localStorage,
    }
  )
);

export default CategoryStore;
